import { ArrowUpRight, Globe } from "lucide-react";
import { SOCIALS } from "../../data/site";
import { useLanguage } from "../../i18n/LanguageContext";
import { TelegramIcon, TikTokIcon, YoutubeIcon } from "./BrandIcons";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

const ICONS = {
    "telegram-group": TelegramIcon,
    "telegram-channel": TelegramIcon,
    tiktok: TikTokIcon,
    youtube: YoutubeIcon,
    website: Globe,
};

export const Community = () => {
    const { t } = useLanguage();
    return (
        <section id="community" data-testid="community-section" className="border-t border-white/5 bg-nx-base py-20 sm:py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
                <SectionHeader
                    label={t("Official Channels")}
                    testId="community"
                    title={<>{t("Follow the Nexora Ecosystem")}</>}
                    description={t("Stay connected with official Nexora Global channels and ecosystem updates.")}
                />
                <div className="mt-14 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
                    {SOCIALS.map((s, i) => {
                        const Icon = ICONS[s.key];
                        return (
                            <Reveal key={s.key} delay={i * 0.06} className="h-full">
                                <a
                                    href={s.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`social-${s.key}`}
                                    className="group flex h-full items-center gap-4 rounded-2xl border border-white/5 bg-nx-elev p-5 transition-all duration-300 hover:-translate-y-0.5 hover:border-nx-lime/30 hover:shadow-[0_8px_32px_rgba(184,255,24,0.05)]"
                                >
                                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-nx-soft text-nx-sub transition-colors duration-300 group-hover:border-nx-lime/30 group-hover:text-nx-lime">
                                        <Icon size={17} />
                                    </span>
                                    <span className="min-w-0">
                                        <span className="block text-sm font-extrabold tracking-wide text-nx-text">{t(s.label)}</span>
                                        <span className="mt-0.5 block truncate text-xs text-nx-mute" dir="ltr">{s.handle}</span>
                                    </span>
                                    <ArrowUpRight size={14} strokeWidth={1.5} className="ms-auto shrink-0 self-start text-nx-mute transition-all duration-300 group-hover:-translate-y-0.5 group-hover:text-nx-lime rtl:-translate-x-0.5" aria-hidden="true" />
                                </a>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
